import OrdenDeVenta from './OrdenDeVenta'

export default OrdenDeVenta
